import React from 'react'
import { Icon } from '~ui'
import Text from '~co/highlights/text'

export default function BookmarksItemHighlights({ className='', highlights }) {
    if (!highlights.length) return null

    return (
        <div className={className}>
            {highlights.map(({ _id, color, text, note })=>(
                <Text 
                    key={_id||'new'}
                    className={'ui-bm-hl-line'}
                    color={color}>
                    {note ? <Icon name='comment' size='micro' className={'ui-bm-hl-note'} /> : null}
                    {text}
                </Text>
            ))}
        </div>
    )
}